// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CELGE","select":"styles_select__U8Rp5"};